module.exports = __webpack_public_path__ + "static/media/user-feedback-icon.5374d70c.svg";